// extracted by mini-css-extract-plugin
module.exports = {"list":"MiniatureFolderSystemFolderList_list__31aZd","overFlowAdjustedList":"MiniatureFolderSystemFolderList_overFlowAdjustedList__ryZZX"};